import AttachmentsUploadController from "../../../javascript/controllers/attachments_upload_controller"

// Tasks::AttachmentsRegionComponent — MC-1091.
//
// Extends the shared upload controller (browse + drag-and-drop, generalised
// in MC-1092) with the two task-specific routes:
//
//   - Paste on the drawer (a screenshot arrives with no filename, so it is
//     named from the task key and a timestamp),
//   - Drag / paste bound to the whole drawer body, not just this section, so
//     an operator can drop or paste anywhere on the task.
//
// Pasting into the comment box is left alone — a paste whose target is a text
// field falls through to the browser so the comment composer still types text.
export default class extends AttachmentsUploadController {
  static values = { taskKey: String }

  connect() {
    super.connect()
    this.onPaste = this.paste.bind(this)
    this.surface.addEventListener("paste", this.onPaste)
  }

  disconnect() {
    this.surface.removeEventListener("paste", this.onPaste)
    super.disconnect()
  }

  // The drawer body is the drop/paste surface ("the drawer"); fall back to
  // this section if it is rendered outside the drawer (e.g. a preview).
  dropSurface() {
    return this.element.closest(".tasks-drawer-view-body") || this.element
  }

  paste(event) {
    // Let the comment box (and any other text field) keep typing text.
    if (this.isTextEntry(event.target)) return

    const files = event.clipboardData && event.clipboardData.files
    if (!files || files.length === 0) return

    event.preventDefault()
    const file = files[0]
    this.upload(file, this.pastedName(file))
  }

  isTextEntry(node) {
    const el = node instanceof Element ? node : node && node.parentElement
    if (!el) return false
    return Boolean(el.closest("input, textarea, [contenteditable='true']"))
  }

  // A pasted screenshot has no filename; name it from the task key and a
  // timestamp so it reads distinctly in the list and the feed.
  pastedName(file) {
    const subtype = (file.type || "image/png").split("/")[1] || "png"
    const stamp = new Date().toISOString().replace(/[:.]/g, "-")
    const key = this.hasTaskKeyValue ? this.taskKeyValue : "attachment"
    return `${key}-${stamp}.${subtype}`
  }
}
